import { Component, Input, OnInit } from '@angular/core';
import { EbiService } from '../shared/ebi.service';
import { ApiService } from '../shared/api.service';


export interface Email {
  to: Array<string>;
  from: string;
  subject: string;
  html: string;
  attachments: Array<any>;
}

@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.css']
})


export class EmailTemplateComponent implements OnInit {
  submitted: boolean;
  @Input() email: Email;
  @Input() location: any;
  @Input() selectedItem: any;
  @Input() idToken: string;
  @Input() placeTests;


  constructor(private ebiService: EbiService, private apiService: ApiService) {
  }

  ngOnInit(): void {
  }

  removeReceivingAddress(email) {
    console.log(email);
    const index = this.email.to.indexOf(email);
    if (index > -1) {
      this.email.to.splice(index, 1);
    }
  }

  addReceivingAddress($event: any) {

    const address = $event.target.value;
    if (address) {
      this.email.to.push(address);
      (document.getElementById('emailInput') as HTMLInputElement).value = '';
      console.log(this.email.to);
    }
  }

  focusEmailInput() {
    (document.getElementById('emailInput') as HTMLInputElement).focus();
  }

  async sendEmail() {
    console.log(this.email);
    this.submitted = true;
    if (!this.email.to[0]) {
      return;
    }
    const emailData = Object.assign({}, this.email);
    console.log(this.email);

    const testType = this.selectedItem?.calculationResult.testType;
    // tslint:disable-next-line:max-line-length
    const pdf = this.selectedItem ? await this.ebiService.createPdfAsBase64(this.selectedItem) : await this.ebiService.createLocationPdfAsBase64(this.location, this.placeTests);
    emailData.attachments[0] = {
      filename: testType ? `${testType[0].toUpperCase() + testType.slice(1)} Result.pdf` : `${this.location.name}.pdf`,
      content: pdf,
      encoding: 'base64'
    };
    console.log(this.email);

    await this.apiService.sendEmail(emailData, this.idToken, this.email);
    this.submitted = false;
    console.log(this.email);


  }
}
